if(!customElements.get('klaviyo-bis-trigger')) {
  class KlaviyoBisTrigger extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('click', this.onButtonClick.bind(this));
    }

    onButtonClick(event) {
      event.preventDefault();

      const container = document.getElementById('klaviyo-bis-button-container');
      if(!container) return;
      const button = container.querySelector('button');
      if(!button) return;

      button.click();
    }
  }
  customElements.define('klaviyo-bis-trigger', KlaviyoBisTrigger);
}